import React, { createContext, useContext } from 'react'
import useNotificationsApi from './useNotificationsApi'

const NotificationContext = createContext()

export const NotificationProvider = ({ children }) => {
  const [state, methods] = useNotificationsApi()

  return (
    <NotificationContext.Provider value={{ state, methods }}>
      {children}
    </NotificationContext.Provider>
  )
}

export const useNotification = () => {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error(
      'useNotification must be used within a NotificationProvider'
    )
  }
  return context
}
